<db-dialog-wrapper [dialog]="this" [width]="'450px'">
  <div class="db-txt-content-dns">
    <div>
      <form [formGroup]="TxtContent" >
        <h3 *ngIf="fromType !== 'MX'">{{'text_addDomainDnsTxtContent' | dbText}}</h3>
        <h3 *ngIf="fromType === 'MX'">{{'text_addDomainDnsMXContent' | dbText}}</h3>
        <label>
          <p>Content</p>
          <textarea formControlName="text" placeholder="{{placeholder}}" class="db-fc-input"
          [value]="txtContent?.text ? txtContent?.text : ''"
          [style.border-color]="TxtContent.controls['text'].invalid && formSubmitted ? '#E95E5B' : null"></textarea>
          <div class="db-invalide-note" *ngIf="TxtContent.controls['text'].invalid && formSubmitted">{{'text_fillRequiredField' | dbText}}</div>
        </label>
        <div class="db-txt-content-dns-buttons">
          <a class="db-button" (click)="close_window()"><span>{{'text_cancel' | dbText}}</span></a>
          <a class="db-button db-button_info" (click)="confirm()"><span>{{'text_saveTags' | dbText}}</span></a>
        </div>
      </form>
    </div>
  </div>
</db-dialog-wrapper>
